module.exports = __webpack_public_path__ + "static/media/Tmc-private-logo-with-text.0978b74d.png";